import { useState } from 'react'
import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { ScrollContainerWithHiddenScrollbar } from 'builder/components/ScrollContainer'
import { TabContentProps } from '../types'

import { TabItem, TabType } from './Tabs'
import { MobileDesignContent } from './MobileDesignContent'
import { DesktopDesignContent } from './DesktopDesignContent'
import { DesignContentProps } from './types'

const TRANSLATION = 'builder.resume_editor.design_tab'

type Props = TabContentProps & DesignContentProps

export const DesignContent = ({
  resume,
  resumeState,
  canScrollTop,
  isRbpStepFlowActive,
  handleDownloadDocument,
  handleShareDocument,
  showResumeDistributionModal,
}: Props) => {
  const { i18n } = useI18n()
  const { isAboveTablet } = useMediaQueries()
  const [activeTab, setActiveTab] = useState<TabType>('templates')

  const tabItems: TabItem<TabType>[] = [
    { id: 'templates', text: i18n.t(`${TRANSLATION}.template_colors.tab`) },
    { id: 'text', text: i18n.t(`${TRANSLATION}.text.tab`) },
    { id: 'layout', text: i18n.t(`${TRANSLATION}.layout.tab`) },
  ]

  const handleTabChange = (tab: TabType) => {
    setActiveTab(tab)
  }

  if (!isAboveTablet) {
    return (
      <>
        <MobileDesignContent
          resume={resume}
          tabItems={tabItems}
          activeTab={activeTab}
          resumeState={resumeState}
          canScrollTop={canScrollTop}
          isRbpStepFlowActive={isRbpStepFlowActive}
          onTabChange={handleTabChange}
          handleShareDocument={handleShareDocument}
          handleDownloadDocument={handleDownloadDocument}
          showResumeDistributionModal={showResumeDistributionModal}
        />
      </>
    )
  }

  return (
    <ScrollContainerWithHiddenScrollbar>
      <DesktopDesignContent
        tab={activeTab}
        resume={resume}
        tabItems={tabItems}
        onTabChange={handleTabChange}
      />
    </ScrollContainerWithHiddenScrollbar>
  )
}
